import classNames from 'classnames';

import { ToothIcon } from '../../../../svgs/toothIcon';
import type { VisitTreatmentWithCount } from '../patientStripOdontogram/hooks';
import { ImplantAndAlignerText } from '../patientStripOdontogram/ImplantAndAlignerText';
import type { TProcedureWithAddressed } from '../patientStripOdontogram/utils';
import { useGetRecommendationName } from '../patientStripOdontogram/utils';

export const SheetTxProceduresInfo = ({
  affectedArea,
  tx,
  procedures,
}: {
  affectedArea: string;
  tx?: VisitTreatmentWithCount[];
  procedures?: TProcedureWithAddressed[];
}) => {
  const { getRecommendationName } = useGetRecommendationName(true);

  if (tx?.length)
    return (
      <div className="vai-m-1 vai-flex vai-flex-row vai-gap-3 vai-py-2 vai-w-full">
        <span className="vai-self-start vai-flex vai-items-center vai-gap-2 vai-font-light">
          <ToothIcon />
          <p className="vai-whitespace-nowrap">{affectedArea}</p>
          <span className="vai-font-extrabold vai-self-start">•</span>
        </span>

        <div className="vai-flex vai-flex-col vai-gap-y-1">
          {tx?.map((treatment) => (
            <span className="vai-flex vai-justify-start vai-items-center vai-font-thin">
              {`${treatment.txGroupLongName.en} ${treatment.txCode} `}
              {treatment.count && treatment.count > 1
                ? `(${treatment.count})`
                : ''}
            </span>
          ))}
        </div>
      </div>
    );
  if (procedures?.length)
    return (
      <div className="vai-m-1 vai-flex vai-flex-row vai-gap-3 vai-py-2 vai-w-full">
        <span className="vai-self-start vai-flex vai-items-center vai-gap-2 vai-font-light">
          <ToothIcon />
          <p>{affectedArea}</p>
          <span className="vai-font-extrabold vai-self-start">•</span>
        </span>

        <div className="vai-flex vai-flex-col vai-gap-1">
          {procedures?.map((procedure) => (
            <span
              className={classNames(
                'vai-flex vai-flex-col vai-items-left vai-font-light',
                { 'vai-text-gray-400': procedure.isAddressed },
              )}
            >
              {getRecommendationName(procedure.name)}
              {procedure.isAddressed && <> &#42;</>}
              <ImplantAndAlignerText
                gapDist={procedure.gapDist}
                hasCrowding={procedure.hasCrowding}
                name={procedure.name}
                summedToothSpacing={procedure.summedToothSpacing}
              />
            </span>
          ))}
        </div>
      </div>
    );
};
